import type { ProjectPickerItemDto } from '../../features/assets/models/asset-api.models';

const MOCK_REFERENCE_ASSET_ID = 'asset-mock-006';

const MOCK_PROJECTS: ProjectPickerItemDto[] = [
  {
    cNumber: 'C27305',
    title: 'SBB digital passenger platform',
    referenceAssetId: null,
  },
  {
    cNumber: 'C21497',
    title: 'Energy sector reference engagement',
    referenceAssetId: MOCK_REFERENCE_ASSET_ID,
  },
  {
    cNumber: 'C30112',
    title: 'Retail cloud migration',
    referenceAssetId: null,
  },
];

export function mockHandleProjectsGet(requestUrl: string): {
  status: number;
  body: ProjectPickerItemDto[];
} {
  const query = requestUrl.includes('?') ? requestUrl.split('?')[1] : '';
  const params = new URLSearchParams(query);
  const search = (params.get('search') ?? '').trim().toLowerCase();
  const limit = Math.min(Math.max(Number(params.get('limit') ?? 20), 1), 50);

  let items = MOCK_PROJECTS;
  if (search) {
    items = items.filter(
      (project) =>
        project.cNumber.toLowerCase().includes(search) ||
        project.title.toLowerCase().includes(search),
    );
  }

  return { status: 200, body: items.slice(0, limit) };
}
